<template>
  <div>
    <PageTitle :route="$route" />

    <PageRowWrapper>
      <IntegratorForm
        v-if="integratorSettings"
        :integratorSettings="integratorSettings"
      />
      <LoadingPage v-if="!integratorSettings" />
    </PageRowWrapper>
  </div>
</template>

<script>
import { mapState, mapActions } from "vuex";
import PageTitle from "@/components/layout/PageTitle";
import PageRowWrapper from "@/components/layout/PageRowWrapper";
import IntegratorForm from "@/components/settings/integrador/integrator/IntegratorForm";
import LoadingPage from "@/components/spinner/LoadingPage";

export default {
  name: "IntegratorEdit",
  components: {
    PageTitle,
    PageRowWrapper,
    IntegratorForm,
    LoadingPage,
  },

  watch: {
    integratorSettings(value) {
      if (value) {
        const { company } = value;

        this.getOrigins(company);
        this.getDriverGroups(company);
      }
    },
  },

  computed: {
    ...mapState({
      integratorSettings: (state) => state.integrator.settingsById,
    }),
  },
  methods: {
    ...mapActions("integrator", ["fetchIntegratorSettingsById"]),

    getOrigins(company) {
      this.$store.dispatch("origin/fetchByCompany", company);
    },

    getDriverGroups(company) {
      this.$store.dispatch("drivergroups/fetchByCompany", company);
    },
  },
  mounted() {
    this.fetchIntegratorSettingsById(this.$route.params.id);
  },
};
</script>
